import ValueTracker from "../../../../../prop-trackers/value-tracker.js";
import SinglePropTracker from "../../../../../prop-trackers/single-prop-tracker.js";
import { ValueTracker as ForEachValueTracker } from "../../../../../prop-tracker-utils/for-each.js";

import { getMaterialFullTypeKey as getKey } from "../../../../data-defs/material-full-types.js";

const typeKeyData = {};

class MaterialTypeGen extends ForEachValueTracker {
    constructor(evtCtx) {
        super();

        this._evtCtx = evtCtx;

        this._dataTracker = new ValueTracker();
        this._typeTracker = new SinglePropTracker();
        this._materialTypeTracker = new SinglePropTracker();
        this._keyTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._dataTracker.listenNeedsUpdate(needsUpdate);
        this._typeTracker.listenNeedsUpdate(needsUpdate);
        this._materialTypeTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(materialData) {
        if (materialData) {
            const materialEvents = this._evtCtx.getEvents(materialData);

            this._dataTracker.setValue(materialData);
            this._typeTracker.track(materialData, materialEvents, "type");
            this._materialTypeTracker.track(materialData, materialEvents, "materialType");
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._dataTracker.deleteValue();
        this._typeTracker.track();
        this._materialTypeTracker.track();
    }

    protected_startUpdate() {
        this._dataTracker.update(({ prop: { newExists: dataExists } }) => {
            if (dataExists) {
                this._typeTracker.update(({ prop: { newValue: type } }) => {
                    typeKeyData.type = type;
                });

                this._materialTypeTracker.update(({ prop: { newValue: materialType } }) => {
                    typeKeyData.materialType = materialType;
                });

                this._keyTracker.setValue(getKey(typeKeyData));
            } else {
                this._keyTracker.deleteValue();
            }
        });

        return this._keyTracker.startUpdate();
    }

    protected_finishUpdate() {
        this._keyTracker.finishUpdate();
    }
}

export default MaterialTypeGen;
